import Reveal from "@/components/Reveal";
import { STORE } from "@/data/store";

const SECTIONS = [
  { title: "1. General", body: `All information on this website is published by ${STORE.name} in good faith and for general information about our store and products. We make no warranty of any kind regarding completeness or accuracy, and any action you take based on this website is at your own discretion.` },
  { title: "2. Product Freshness", body: "Fresh produce, dairy and other perishables are sourced daily and sold on a best-quality basis. Natural variation in size, colour and taste is normal for farm-direct goods. Please consume perishables promptly and store them as advised at the counter." },
  { title: "3. Price Variation", body: "Prices of fruits, vegetables and other daily-market produce fluctuate with mandi rates. Prices shown on this website are indicative counter rates and may differ on the day of your purchase. The rate board at the shop is the final word." },
  { title: "4. Organic & Sourcing Claims", body: "Where we describe products as organic, stone-ground, cold-pressed or farm-direct, these descriptions reflect information provided by our farmers and suppliers, along with our own long experience. They are not a substitute for certified labelling where certification applies." },
  { title: "5. Health & Allergy Advisory", body: "Our store handles nuts, gluten, dairy and spices on shared shelves. If you have allergies or dietary medical conditions, please consult your physician and inform us before purchase. Nothing on this website constitutes medical or nutritional advice." },
  { title: "6. External Links", body: "This website links to third-party services such as WhatsApp and Google Maps for your convenience. We do not control and are not responsible for the content or practices of those services." },
  { title: "7. Contact for Concerns", body: `If any product does not meet your expectation, bring it back or call us at ${STORE.phoneDisplay} — we will replace it or make it right. That has been our policy since ${STORE.est}, and it stands today.` },
];

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page" className="pt-32 lg:pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <Reveal>
          <p className="font-code text-xs uppercase tracking-[0.25em] text-terra mb-4">Legal</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.1]" data-testid="disclaimer-title">
            Disclaimer
          </h1>
          <p className="font-code text-xs tracking-wider text-muted-foreground mt-5">
            Last updated: July 2026 · {STORE.name}
          </p>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mt-6">
            Honesty works both ways. Here is the fine print, written as plainly as we
            speak at the counter.
          </p>
        </Reveal>

        <div className="mt-14 space-y-10" data-testid="disclaimer-sections">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.04, 0.3)}>
              <section className="border-b border-border pb-10">
                <h2 className="font-display text-xl sm:text-2xl font-medium leading-snug">{s.title}</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mt-3">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
